import { useEffect } from 'react';

const isMobileDevice = () =>
  'ontouchstart' in window || navigator.maxTouchPoints > 0;

export const useContextMenuChange = () => {
  const handleContextMenu = (event: Event) => {
    event.preventDefault();
  };

  const handleSelectStart = (event: Event) => {
    const target = event.target as HTMLElement;
    const isTypingElement =
      target.tagName === 'INPUT' ||
      target.tagName === 'TEXTAREA' ||
      target.isContentEditable;
    if (!isTypingElement) {
      event.preventDefault();
    }
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    // Check if the key pressed is not a modifier key (Shift, Ctrl, Alt)
    const target = event.target as HTMLElement;

    // Allow typing in input, textarea, and contentEditable elements
    const isTypingElement =
      target.tagName === 'INPUT' ||
      target.tagName === 'TEXTAREA' ||
      target.isContentEditable;

    if (isTypingElement) {
      return; // allow default behavior
    }

    // Block everything else (e.g. F12, Ctrl+S)
    event.preventDefault();
  };

  useEffect(() => {
    // Attach the contextmenu event listener when the component mounts
    document.body.addEventListener('contextmenu', handleContextMenu);

    // Attach the keydown event listener when the component mounts
    document.addEventListener('keydown', handleKeyDown);

    // On mobile: disable long-press text selection and "Search in Google" callout
    let styleElement: HTMLStyleElement | null = null;
    if (isMobileDevice()) {
      document.addEventListener('selectstart', handleSelectStart, {
        passive: false,
      });

      styleElement = document.createElement('style');
      styleElement.textContent = `
        body {
          -webkit-user-select: none;
          user-select: none;
          -webkit-touch-callout: none;
        }
        input, textarea, [contenteditable] {
          -webkit-user-select: text;
          user-select: text;
          -webkit-touch-callout: default;
        }
      `;
      document.head.appendChild(styleElement);
    }

    return () => {
      document.body.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      if (isMobileDevice()) {
        document.removeEventListener('selectstart', handleSelectStart);
        styleElement?.remove();
      }
    };
  }, []);
};
